import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { authApi } from '../api/client';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [firm, setFirm] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem('advbr_token');
    if (!token) { setLoading(false); return; }
    try {
      const data = await authApi.me();
      setUser(data.user); setFirm(data.firm);
    } catch { localStorage.removeItem('advbr_token'); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const data = await authApi.login({ email, password });
    localStorage.setItem('advbr_token', data.token);
    setUser(data.user); setFirm(data.firm);
    return data;
  };

  const register = async (payload) => {
    const data = await authApi.register(payload);
    localStorage.setItem('advbr_token', data.token);
    setUser(data.user); setFirm(data.firm);
    return data;
  };

  const logout = () => {
    localStorage.removeItem('advbr_token');
    setUser(null); setFirm(null);
  };

  return (
    <AuthContext.Provider value={{ user, firm, setFirm, loading, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
